import Colors from "@constants/Colors";

interface SortIconProps {
  order: string;
}

const SortIcon = ({ order }: SortIconProps) => {
  return (
    <>
      {order === "normal" && (
        <svg
          width="16"
          height="16"
          viewBox="0 0 9 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.45645 1.51319C8.18158 1.25447 7.73705 1.27437 7.48828 1.57289L4.15482 5.57305L4.1096 5.63357C3.82156 6.06585 4.12744 6.66654 4.66699 6.66654H11.3339L11.4094 6.66254C11.9258 6.60708 12.1915 5.98754 11.8461 5.57305L8.51262 1.57289L8.45645 1.51319ZM11.8913 10.3663C12.1793 9.93401 11.8735 9.33331 11.3339 9.33331H4.66699L4.59154 9.33732C4.07506 9.39278 3.80941 10.0123 4.15482 10.4268L7.48828 14.427L7.54445 14.4867C7.81933 14.7454 8.26385 14.7255 8.51262 14.427L11.8461 10.4268L11.8913 10.3663Z"
            fill="#21263B"
          />
        </svg>
      )}
      {order === "asc" && (
        <svg
          width="9"
          height="14"
          viewBox="0 0 9 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.89131 9.36629C8.17934 8.93401 7.87347 8.33331 7.33391 8.33331H0.66699L0.591539 8.33732C0.0750575 8.39278 -0.190591 9.01231 0.154823 9.42681L3.48828 13.427L3.54445 13.4867C3.81933 13.7454 4.26385 13.7255 4.51262 13.427L7.84608 9.42681L7.89131 9.36629Z"
            fill={Colors.neutral_gray_300}
          />
          <path
            d="M4.45645 0.513189C4.18158 0.254467 3.73705 0.274369 3.48828 0.572894L0.154823 4.57305L0.109596 4.63357C-0.178438 5.06585 0.127436 5.66654 0.66699 5.66654H7.33391L7.40936 5.66254C7.92584 5.60708 8.19149 4.98754 7.84608 4.57305L4.51262 0.572894L4.45645 0.513189Z"
            fill="#101323"
          />
        </svg>
      )}
      {order === "desc" && (
        <svg
          width="16"
          height="16"
          viewBox="0 0 9 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.8913 10.3663C12.1793 9.93401 11.8735 9.33331 11.3339 9.33331H4.66699L4.59154 9.33732C4.07506 9.39278 3.80941 10.0123 4.15482 10.4268L7.48828 14.427L7.54445 14.4867C7.81933 14.7454 8.26385 14.7255 8.51262 14.427L11.8461 10.4268L11.8913 10.3663Z"
            fill="#21263B"
          />
          <path
            d="M8.45645 1.51319C8.18158 1.25447 7.73705 1.27437 7.48828 1.57289L4.15482 5.57305L4.1096 5.63357C3.82156 6.06585 4.12744 6.66654 4.66699 6.66654H11.3339L11.4094 6.66254C11.9258 6.60708 12.1915 5.98754 11.8461 5.57305L8.51262 1.57289L8.45645 1.51319Z"
            fill={Colors.neutral_gray_300}
          />
        </svg>
      )}
    </>
  );
};

export default SortIcon;
